import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function query(_x) {
  return _query.apply(this, arguments);
}

function _query() {
  _query = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        id,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/orders',
              data: queryParams,
              method: 'POST'
            });

          case 4:
            response = _context.sent;
            id = response.data.id;
            ctx.commit('addId', id);
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _query.apply(this, arguments);
}

export function addProducts(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('addProducts', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function addAddress(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('addAddress', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function addInvoice(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('addInvoice', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function addId(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('addId', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function addCard(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('addCard', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function clean(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('clean', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function get(_x2) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        response,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: '/orders',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context2.sent;
            ctx.commit('items', response.data.items);
            return _context2.abrupt("return", response);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", _context2.t0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return _get.apply(this, arguments);
}